module.exports = __webpack_public_path__ + "static/media/upArrow.c73708f1.svg";